import React from 'react';
import { Checkbox } from '@material-ui/core';
import clsx from 'clsx';

import { ICustomCheckboxProps } from './interfaces';
import { useStyles } from './styles';

const CustomCheckbox: React.FC<ICustomCheckboxProps> = ({
  error = false,
  ...props
}: ICustomCheckboxProps) => {
  const classes = useStyles();

  return (
    <Checkbox
      className={clsx({ [classes.erroredCheckbox]: error })}
      {...props}
    />
  );
};

export default CustomCheckbox;
